import { useCallback } from 'react';

import { downloadAsFile, type FileType } from '../utils/downloadFileUtils';

const useDownloadFileContent = (capturePosthogEvent: () => void) => {
  const downloadFileContent = useCallback(
    (fileContent: string | undefined, fileType: FileType): void => {
      if (!fileContent) return;
      downloadAsFile(fileContent, fileType);
      capturePosthogEvent();
    },
    [capturePosthogEvent]
  );

  return {
    downloadFileContent
  };
};

export default useDownloadFileContent;
